import { ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config } from '../../shared';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import {FileLabelContainerModel} from '../../../../../../models';

@Injectable({providedIn: 'root'})

export class FileLabelService extends BaseApiTemplateService<FileLabelContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'labels/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FM_MODULE + 'labels/backoffice-ep';
    this.httpClient = http;
  }
}
